import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  UntypedFormBuilder,
  Validators,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'src/app/loader/loader.service';
import { SharedsService } from 'src/app/shareds/shareds.service';
import { LoginService } from '../login/login.service';
import { ToastrService } from 'ngx-toastr';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Helpers } from '../home/users/helper';
import { ActivatedRoute, Router } from '@angular/router';
declare const window: any;
@Component({
  selector: 'app-self-service-onboard',
  templateUrl: './self-service-onboard.component.html',
  styleUrls: ['./self-service-onboard.component.scss'],
})
export class SelfServiceOnboardComponent implements OnInit {
  @Input() validuser = {
    isUserValid: false,
  };
  @Input() signUp = {
    slefOnboard: false,
  };
  state: any;
  @Input() resetForm!: boolean;
  @Input()
  set user(value: { name: string; email: string; state: string }) {
    if (value) {
      this.state = value.state;
      this.signUpForm.patchValue({
        name: value.name,
        email: value.email,
      });
    }
    if (this.state === 'google_signup') {
      this.signUpForm.get('name')?.disable();
      this.signUpForm.get('email')?.disable();
    }
  }
  signUpForm: FormGroup;
  sharedService: SharedsService;
  loader: LoaderService;
  loginService: LoginService;
  translate: TranslateService;
  defaultLanguage: any = 'en';
  submitted: boolean;
  countriesList = [];
  industryList: any = [
    'Automotive',
    'Beauty',
    'Spa and Salon',
    'Clothing and Apparel',
    'Education',
    'Entertainment',
    'Event Planning and Service',
    'Finance and Banking',
    'Food and Grocery',
    'Public Service',
    'Hotel and Lodging',
    'Medical and Health',
    'Non - Profit',
    'Professional Services',
    'Shopping and Retail',
    'Travel and Transportation',
    'Restaurant',
    'Other',
  ];
  config = {
    displayKey: 'name',
    search: true,
    height: '175px',
    placeholder: 'Select',
    limitTo: this.countriesList.length,
    moreText: 'more',
    noResultsFound: 'No results found!',
    searchPlaceholder: 'Search',
    searchOnKey: 'name',
  };
  configIndustry = {
    displayKey: 'label',
    search: true,
    height: '175px',
    placeholder: 'Select',
    limitTo: this.industryList.length,
    moreText: 'more',
    noResultsFound: 'No results found!',
    searchPlaceholder: 'Search',
    // searchOnKey: 'name',
  };
  choosePlan = false;
  email = '';
  planList = [];
  choosenPlan: any;
  formBuilder: UntypedFormBuilder;
  selectedSignupOption = 'self';
  @Output() dataEmitter = new EventEmitter<object>();
  loadershow = false;
  showPassword: boolean = false;
  googleParams: {
    client_id: string;
    // client_id: "640604431937-f8a1qtodr1r8iehu514l0m1mpcetets1.apps.googleusercontent.com", // NOSONAR
    redirect_uri: string;
  };
  constructor(
    private readonly fb: FormBuilder,
    private readonly injector: Injector,
    private readonly toastr: ToastrService,
    private readonly deviceService: DeviceDetectorService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
  ) {
    this.sharedService = this.injector.get<SharedsService>(SharedsService);
    this.loader = this.injector.get<LoaderService>(LoaderService);
    this.loginService = this.injector.get<LoginService>(LoginService);
    this.translate = this.injector.get<TranslateService>(TranslateService);
    this.translate.setDefaultLang('en');
    this.translate.use(this.defaultLanguage ? this.defaultLanguage : 'en');
    this.formBuilder =
      this.injector.get<UntypedFormBuilder>(UntypedFormBuilder);
    this.signUpForm = this.formBuilder.group(
      {
        name: new FormControl('', [Validators.required]),
        companyName: new FormControl('', [Validators.required]),
        industry: new FormControl('', [Validators.required]),
        email: new FormControl('', [Validators.required, Validators.email]),
        password: new FormControl('', [
          Validators.required,
          Validators.minLength(6),
        ]),
        confirmPassword: new FormControl('', [Validators.required]),
        city: new FormControl('', [Validators.required]),
        zip: new FormControl('', [Validators.required]),
        country: new FormControl('', [Validators.required]),
      },
      {
        validator: [Helpers.passwordValidator, this.passwordsMatchValidator],
      },
    );
  }
  ngOnInit() {
    this.fetchCountries();
    this.listPlan();
    this.setSOSCredentials();
    if (this.validuser?.['isUserValid']) {
      this.signUpForm.patchValue({
        email: this.validuser?.['email'] || 'user@example.com',
      });
    }
    this.industryList = this.industryList.map((item, index) => ({
      label: item,
      order: index,
    }));
    this.industryList = [...this.industryList]
      .filter((i) => i.label !== 'Other')
      .sort((a, b) => a.label.localeCompare(b.label))
      .concat({ label: 'Other' });
  }
  onSubmit() {
    this.submitted = true;
    if (!this.signUpForm.invalid) {
      this.choosePlan = true;
      this.dataEmitter.emit({ valid: true });
      const rawFormValues = this.signUpForm.getRawValue();
      const name = rawFormValues.name?.trim();
      const email =
        rawFormValues.email?.trim() ?? this.signUpForm?.value?.email?.trim();
      console.log('name', name, email);
      const arg = {
        name: name ?? this.signUpForm?.value?.name?.trim(),
        country: this.signUpForm?.value?.country?.name,
        email: email.toLowerCase(),
        companyName: this.signUpForm?.value?.companyName?.trim(),
        industry: this.signUpForm?.value?.industry?.label?.trim(),
        zip: this.signUpForm?.value?.zip,
        city: this.signUpForm?.value?.city,
      };
      this.loginService.addHubspot(arg)?.subscribe({
        next: (data) => {
          console.log('Hubspot');
        },
      });
    }
  }

  get f() {
    return this.signUpForm.controls;
  }

  fetchCountries(): void {
    this.loginService.getCountries().subscribe({
      next: (data) => {
        this.countriesList = data?.['info']?.sort((a, b) =>
          a?.name.localeCompare(b?.name),
        );
        if (data.ipCountryCode) {
          const country = this.countriesList.find(
            (item) =>
              item.code.toLowerCase() === data.ipCountryCode.toLowerCase(),
          );
          this.signUpForm.patchValue({
            country: country || '',
          });
        }
      },
      error: (err) => {
        console.error('Error fetching countries:', err);
      },
    });
  }
  mofifyMenuPlanList() {
    this.planList.forEach((item) => {
      item['tabs'] = [];
      item.details?.menu?.forEach((tab) => {
        const subMenu = tab.subMenu;
        subMenu?.forEach((sub) => item['tabs'].push(sub));
      });
    });
  }
  onPlanChoose(plan) {
    this.choosenPlan = plan;
    this.loader.display(true);
    if (plan?.name?.toLowerCase() !== 'enterprise') {
      this.selfOnboardApi();
    }
  }
  listPlan() {
    this.loginService.getPlanDetails().subscribe({
      next: (data) => {
        if (data.info) {
          this.planList = data.info;
        }
        this.mofifyMenuPlanList();
      },
      error: (err) => {
        console.error('Error listPlan:', err);
      },
    });
  }
  selfOnboardApi() {
    const rawFormValues = this.signUpForm.getRawValue();
    const name = rawFormValues.name?.trim();
    const email =
      rawFormValues.email?.trim() ?? this.signUpForm?.value?.email?.trim();
    console.log('name', name, email);
    const browser_details = this.deviceService.getDeviceInfo();
    const arg = {
      planId: this.choosenPlan._id,
      name: name ?? this.signUpForm?.value?.name?.trim(),
      country: this.signUpForm?.value?.country?.name,
      email: email.toLowerCase(),
      password: this.signUpForm?.value?.password,
      companyName: this.signUpForm?.value?.companyName?.trim(),
      industry: this.signUpForm?.value?.industry?.label?.trim(),
      zip: this.signUpForm?.value?.zip,
      city: this.signUpForm?.value?.city,
      browser_details: browser_details,
      is_verified: this.state === 'google_signup',
    };
    arg['priceId'] = this.choosenPlan.priceId;
    this.choosePlan = false;
    this.dataEmitter.emit({ signUpData: arg, signUp: true });
  }

  selectedSignupChange(value) {
    this.selectedSignupOption = value;
  }

  submitEmailValidation() {
    this.submitted = true;
    if (!this.email) {
      return;
    } else {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      const validationResult = emailRegex.test(this.email) ? null : true;
      if (validationResult) {
        this.toastr.error(this.translate.instant('login.must_be_valid'));
        return;
      }
    }
    this.loadershow = true;
    this.loginService.signUpEmailValidate(this.email?.trim()).subscribe({
      next: (data) => {
        if (data.status === 200) {
          this.toastr.info('', data.info);
          this.dataEmitter.emit({ valid: true });
        } else {
          this.toastr.error('', data.info);
          this.email = '';
          this.submitted = false;
        }
        this.loadershow = false;
      },
      error: (err) => {
        console.error('Error listPlan:', err);
      },
    });
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }
  loginUsingGoogle() {
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${this.googleParams['client_id']}&redirect_uri=${this.googleParams['redirect_uri']}&response_type=code&scope=profile email&state=google_signup&prompt=select_account`;
  }
  setSOSCredentials() {
    const uiURL = window.location?.origin || 'https://unified.ai';
    this.googleParams = {
      client_id:
        '914067849245-4fuulnaodra6ejquu4dlplg6e6evh3ci.apps.googleusercontent.com',
      // client_id: "53719461969-a17bmh7gp8hkca4fntugdmn1u4uesrs2.apps.googleusercontent.com", // NOSONAR
      redirect_uri: `${uiURL}/signup`,
    };
  }
  passwordsMatchValidator(form: FormGroup) {
    const password = form.get('password')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { passwordMismatch: true };
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['resetForm'] && changes['resetForm'].currentValue === true) {
      this.signUpForm.get('name')?.enable();
      this.signUpForm.get('email')?.enable();
      this.signUpForm.reset();
      this.submitted = false;
      this.choosePlan = false;
      this.state = null;
      console.log('this.satae', this.state);
    }
  }
}
